import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Form, Button } from "react-bootstrap";

import { formatDate } from "../../../../utils/date-utils/date-utils";

export const EmailSearch = ({ to, subject, status, date, handleSearch }) => {
  const intl = useIntl();

  const [toValue, setToValue] = useState(to ? to : "");
  const [subjectValue, setSubjectValue] = useState(subject ? subject : "");
  const [statusValue, setStatusValue] = useState(status ? status : "");
  const [dateValue, setDateValue] = useState(date ? date : "");

  const onSearch = (e) => {
    e.preventDefault();
    handleSearch({
      to: toValue === "" ? null : toValue,
      subject: subjectValue === "" ? null : subjectValue,
      status: statusValue === "ALL" ? null : statusValue,
      date: dateValue === "" ? null : new Date(dateValue).getTime(),
    });
  };

  return (
    <Form onSubmit={onSearch}>
      <Row>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.emails.form.to",
            })}
            onChange={(e) => setToValue(e.target.value)}
            value={toValue}
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.emails.form.subject",
            })}
            onChange={(e) => setSubjectValue(e.target.value)}
            value={subjectValue}
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Select
            onChange={(e) => setStatusValue(e.target.value)}
            value={statusValue}
          >
            <option value="ALL">
              <FormattedMessage id="data.emails.form.status.value.ALL" />
            </option>
            <option value="NEW">
              <FormattedMessage id="data.emails.form.status.value.NEW" />
            </option>
            <option value="SENDED">
              <FormattedMessage id="data.emails.form.status.value.SENDED" />
            </option>
            <option value="EXCEPTION">
              <FormattedMessage id="data.emails.form.status.value.EXCEPTION" />
            </option>
          </Form.Select>
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="date"
            onChange={(e) => setDateValue(e.target.value)}
            value={
              dateValue ? formatDate(new Date(dateValue), "YYYY-MM-DD") : ""
            }
          />
        </Col>
        <Col xs={12} md={2} className="text-md-end">
          <Button type="submit">
            <FormattedMessage id="button.search" />
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

EmailSearch.propTypes = {
  to: PropTypes.string,
  subject: PropTypes.string,
  status: PropTypes.string,
  date: PropTypes.number,
  handleSearch: PropTypes.func.isRequired,
};
